<template>
	<sf-data-table
		ref="table"
		:columns="columns"
		:rows="rows"
		paging
		selection
		:excel="isButton_(scrId, 'EX')"
		@changedPage="onChangePage"
		v-bind="commCdTypePagingInfo"
		@row-dblclick="searchCommCdList"
		index
		rowKey="rnum"
		:pageUnit="commCdTypePagingInfo.pageUnit"
		:pageArray="screen.pageArray"
		:totalSize="commCdTypePagingInfo.totalSize"
	>
		<template v-slot:actionsLeft>
			<sf-button line v-if="isButton_(scrId, 'AD')" icon="square-plus" :onClick="addRow">{{ getButtonMsg_(scrId, 'AD') }}</sf-button>
			<sf-button line v-if="isButton_(scrId, 'AD')" icon="file" :onClick="() => onClickButton('save')">{{
				getMessage_('SWCC000138')
			}}</sf-button>
			<sf-button line v-if="isButton_(scrId, 'CD')" icon="trash" color="error" :onClick="() => onClickButton('delete')">{{
				getButtonMsg_(scrId, 'CD')
			}}</sf-button>
		</template>
	</sf-data-table>
</template>
<script>
import * as yup from 'yup';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import { rootComputed } from '@/store/common/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	async created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	mounted() {
		this.$sf_toggleLoading(true);
		Promise.all([this.searchCommCdTypeOptions_(), this.searchCommCdType_()])
			.catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			})
			.finally(() => this.$sf_toggleLoading(false));
	},
	computed: {
		...serviceComputed,
		...rootComputed,
		// options() {
		// 	return this.useYnOptions.slice(1, 3);
		// },
		rows() {
			return this.commCdTypeRows;
		},

		commCdTypeSchema() {
			return yup.object().shape({
				commCdType: yup
					.string()
					.trim()
					.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('SWCC000168')]))
					.min(1, this.$sf_formatString(this.getMessage_('SWCC000176'), [this.getMessage_('SWCC000168'), 1]))
					.max(20, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('SWCC000168'), 20])),
				commCdTypeName: yup
					.string()
					.trim()
					.min(1, this.$sf_formatString(this.getMessage_('SWCC000176'), [this.getMessage_('SWCC000169'), 1]))
					.max(40, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('SWCC000169'), 40])),
				commCdTypeDesc: yup
					.string()
					.trim()
					.max(200, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('SWCC000149'), 200]))
			});
		},
		columns() {
			return [
				// { label: 'No.', prop: 'rnum', width: '130px' },
				// { label: this.getMessage_('SWCC000141'), prop: 'status', width: '90px' },
				{
					label: this.getMessage_('SWCC000168'),
					prop: 'commCdType',
					width: '300px',
					form: {
						type: 'input',
						maxLength: 20,
						isDisabled: this.isAdded
					}
				},
				{
					label: this.getMessage_('SWCC000169'),
					prop: 'commCdTypeName',
					width: '300px',
					form: {
						type: 'input',
						maxLength: 100
					}
				},
				{
					label: this.getMessage_('SWCC000149'),
					prop: 'commCdTypeDesc',
					width: '300px',
					form: {
						type: 'input',
						maxLength: 1000
					}
				},
				{
					label: this.getMessage_('SWCC000144'),
					prop: 'commCdTypeSort',
					width: '130px',
					form: {
						type: 'number'
					}
				},
				// {
				// 	label: this.getMessage_('SWCC000145'),
				// 	prop: 'useYn',
				// 	width: '170px',
				// 	form: {
				// 		type: 'select',
				// 		options: this.options
				// 	}
				// },
				{ label: this.getMessage_('SWCC000005'), prop: 'regId', width: '150px' },
				{ label: this.getMessage_('SWCC000146'), prop: 'regDt', width: '180px' },
				// { label: this.getMessage_('SWCC000143'), prop: 'regIp', width: '200px' },
				{ label: this.getMessage_('SWCC000172'), prop: 'chgId', width: '150px' },
				{ label: this.getMessage_('SWCC000171'), prop: 'chgDt', width: '180px' }
				// { label: this.getMessage_('SWCC000173'), prop: 'chgIp', width: '200px' },
			];
		}
	},
	methods: {
		...serviceMethods,
		isAdded: ({ row }) => row.status !== 'I',
		searchCommCdList({ commCdType, status }) {
			if (status === 'I') {
				return;
			}
			this.$sf_toggleLoading(true);
			this.setCurrentCommCdType_(commCdType);
			this.searchCommCd_({ commCdType, ...this.commCdPagingInfo, currentPage: 1 })
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => this.$sf_toggleLoading(false));
		},
		onChangePage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				return; //초기 중복 조회 방지.
			}
			this.$sf_toggleLoading(true);
			this.searchCommCdType_({ currentPage: currentPageVal, pageUnit: pageUnitVal })
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => this.$sf_toggleLoading(false));
		},
		getSelectedRows() {
			const defaultObj = this.commCdTypeSchema.cast();
			const rows = this.$refs.table
				.getSelectedRows()
				.map(row => _(row).omitBy(_.isNull).omitBy(_.isUndefined).defaults(defaultObj).value());
			return rows;
		},
		addRow() {
			const selectedRows = this.$refs.table.getSelectedRows();
			const toggleRowSelection = this.$refs.table.getTable().toggleRowSelection;
			this.addCommCdTypeRow_().then(addedRow => {
				selectedRows.push(addedRow);
				selectedRows.forEach(row => {
					toggleRowSelection(row);
				});
			});
			this.$refs.table.scrollBottom();
		},
		async onClickButton(action) {
			const selectedRows = this.getSelectedRows();
			if (!selectedRows || selectedRows.length === 0) {
				const msg = action === 'save' ? 'SWCC000434' : 'SWCC000418';
				this.$sf_showMessage({
					icon: 'error',
					message: this.getMessage_(msg)
				});
			}
			const messageCode = {
				save: 'SWCC000501',
				delete: 'SWCC000108'
			}[action];
			const clickFn = {
				save: this.saveRows,
				delete: this.deleteRows
			}[action];
			await this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message: this.getMessage_(messageCode),
				buttons: [{ title: 'Confirm', clickFn }] //this.getMessage_('SWCC000203')
			});
		},
		async saveRows() {
			const selectedRows = this.getSelectedRows();
			const fail = (
				await Promise.all(
					selectedRows.map(row =>
						this.commCdTypeSchema
							.validate(row)
							.then(() => ({ isValid: true }))
							.catch(e => ({ isValid: false, ...e }))
					)
				)
			).filter(r => !r.isValid);
			if (fail.length > 0) {
				this.$sf_showMessage({ icon: 'error', message: fail[0].message });
				return;
			}
			this.$sf_toggleLoading(true);
			this.saveCommCdType_(selectedRows)
				.then(({ code, message }) =>
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message
					})
				)
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => this.$sf_toggleLoading(false));
		},
		deleteRows() {
			this.$sf_toggleLoading(true);
			this.deleteCommCdType_(this.getSelectedRows())
				.then(header =>
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					})
				)
				.finally(() => this.$sf_toggleLoading(false));
		}
	},
	watch: {
		rows() {
			const target = _.first(this.$refs.table.$el.getElementsByClassName('el-table__body-wrapper')) || {};
			target.scrollLeft = 0;
		}
	},
	data() {
		return {};
	}
};
</script>

<style>
.rcv_id_label {
	text-decoration: none !important;
}
.rcv_id_blue * {
	color: rgb(40, 40, 255);
	font-weight: bolder;
	cursor: pointer;
	text-decoration: underline;
}
.commonCode__pointerCell {
	cursor: pointer;
}
</style>
